import { render, staticRenderFns } from "./EditRewardsRow.vue?vue&type=template&id=abbe2366&scoped=true"
import script from "./EditRewardsRow.vue?vue&type=script&lang=js"
export * from "./EditRewardsRow.vue?vue&type=script&lang=js"
import style0 from "./EditRewardsRow.vue?vue&type=style&index=0&id=abbe2366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbe2366",
  null
  
)

export default component.exports